import React, { useState, useEffect } from 'react';
import { navigateTo } from "../../../utils/navigation";
import { toast } from 'react-toastify';
import './auth.css';
import { useDispatch, useSelector } from "react-redux";
import {loginMerchant, restoreSession, logoutMerchant  } from "../../../features/merchant/merchantThunks";
import featureFlags from "../../../config/featureFlags";
const enquiryStatusConfig = {
  incomplete: {
    label: "Pending",
    badgeClass: "bg-danger",
  },
  paymentPending: {
    label: "paymentPending",
    badgeClass: "bg-warning",
  },
  paymentComplete: {
    label: "complete",
    badgeClass: "bg-success",
  },
  underReview: {
    label: "Under Review",
    badgeClass: "bg-info",
  },
};


const MerchantInquiryStatus = () => {
  const [currentView, setCurrentView] = useState('success');
  const [loading, setLoading] = useState(false); // no backend, no loading check

  const showTracking = () => setCurrentView('tracking');
  const backToSuccess = () => setCurrentView('success');
  const dispatch = useDispatch();
const { user, accessToken } = useSelector(state => state.merchant);

useEffect(() => {
  dispatch(restoreSession());
}, [dispatch]);

useEffect(() => {
  dispatch(restoreSession());
}, [dispatch]);

useEffect(() => {
  if (!user || !accessToken) return;

  // ❗ STAY ON PAGE
  if (user.enquiryStatus === "incomplete") {
    return;
  }

  // 👉 Redirect only when status changes
  if (user.enquiryStatus === "paymentPending") {
    navigateTo(featureFlags.ENABLE_MERCHANT_SUBSCRIPTION ? "/buy-subscription" : "/dashboard");
    return;
  }

  if (user.enquiryStatus === "paymentComplete") {
    navigateTo("/dashboard");
    return;
  }
}, [user?.enquiryStatus, accessToken]);



  const enquiryStatusKey = user?.enquiryStatus || "incomplete";

const enquiryStatus =
  enquiryStatusConfig[enquiryStatusKey] ||
  enquiryStatusConfig.incomplete;

const handleBack = async () =>{
   await dispatch(logoutMerchant());
    toast.success("Logged out successfully!");
  navigateTo("/merchant-login");
};

 const handleBackHome = async () => {
    navigateTo("/");
  };


  const SuccessPage = () => (
    <div className="status-container">
      <div className="container-fluid">
        <div className="row justify-content-center min-vh-100 align-items-center">
          <div className="col-12 col-lg-10 col-xl-8 col-xxl-7">
            <div className="status-card horizontal-layout">
        <div className="status-header text-center mb-4">
         <h4 className="status-title">Inquiry Status</h4>
          <h4 className="status-title">
          <span className={`badge ${enquiryStatus.badgeClass}`}>
                 {enquiryStatus.label}
            </span>
         </h4>
         </div>


              <div className="row align-items-center">
                <div className="col-12 col-lg-5 text-center mb-4 mb-lg-0">
                  <div className="success-icon-wrapper mb-3">
                    <div className="success-icon">
                      <i className="fas fa-check"></i>
                    </div>
                  </div>
                  <h3 className="success-heading">Inquiry Submitted!</h3>
                  <p className="success-subtext">Thank you!</p>
                  <p className="success-description">
                    Your merchant inquiry has been successfully submitted.
                  </p>
                </div>

                <div className="col-12 col-lg-7">
                  <div className="info-cards-container mb-4">
                    <div className="info-card mb-3">
                      <div className="info-icon-wrapper">
                        <div className="info-icon representative">
                          <i className="fas fa-user-tie"></i>
                        </div>
                      </div>
                      <div className="info-content">
                        <h6 className="info-title">Our Representative Will Contact You</h6>
                        <p className="info-subtitle">Within 24-48 hours</p>
                      </div>
                    </div>

                    <div className="info-card mb-3">
                      <div className="info-icon-wrapper">
                        <div className="info-icon next-steps">
                          <i className="fas fa-clipboard-check"></i>
                        </div>
                      </div>
                      <div className="info-content">
                        <h6 className="info-title">Next Steps</h6>
                        <p className="info-subtitle">Document verification & onboarding</p>
                      </div>
                    </div>

                    <div className="info-card mb-4">
                      <div className="info-icon-wrapper">
                        <div className="info-icon help">
                          <i className="fas fa-question-circle"></i>
                        </div>
                      </div>
                      <div className="info-content">
                        <h6 className="info-title">Need Help?</h6>
                        <p className="info-subtitle">Contact support: 9997427354</p>
                      </div>
                    </div>
                  </div>

                  <div className="action-buttons">
                    <div className="row g-3">
                      <div className="col-12 col-sm-6">
                        <button 
                          className="btn btn-primary btn-lg w-100"
                          onClick={showTracking}
                        >
                          <i className="fas fa-search me-2"></i>
                          Track Application
                        </button>
                      </div>
                      <div className="col-12 col-sm-6">
                        <button  
                          className="btn btn-outline-primary btn-lg w-100"
                          onClick={handleBack}
                        >
                          <i className="fas fa-home me-2"></i>
                          Back to Login
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const TrackingPage = () => (
    <div className="status-container">
      <div className="container-fluid">
        <div className="row justify-content-center min-vh-100 align-items-center">
          <div className="col-12 col-lg-10 col-xl-8 col-xxl-7">
            <div className="status-card horizontal-layout">
              <div className="status-header text-center mb-4">
                <button 
                  className="btn btn-link p-0 float-start"
                  onClick={backToSuccess}
                >
                  <i className="fas fa-arrow-left"></i>
                </button>
                <h4 className="status-title">Application Tracking</h4>
              </div>

              <div className="row align-items-center">
                <div className="col-12 col-lg-8">
                  <div className="tracking-container">
                    {["Application Submitted", "Under Review", "Representative Contact", "Onboarding"].map((step, index) => {
                      const statusClass = index < 1 ? "paymentComplete" : index === 1 ? "current" : "pending";
                      return (
                        <div className={`tracking-step ${statusClass}`} key={index}>
                          <div className="step-indicator">
                            <div className={`step-number ${statusClass}`}>
                              {statusClass === "paymentComplete" ? <i className="fas fa-check"></i> : index + 1}
                            </div>
                            {index < 3 && <div className={`step-line ${statusClass === "paymentComplete" ? "paymentComplete" : ""}`}></div>}
                          </div>
                          <div className="step-content">
                            <h6 className="step-title">{step}</h6>
                            <p className="step-description">
                              {step === "Application Submitted" ? "Your inquiry has been received" :
                               step === "Under Review" ? "Our team is reviewing your application" :
                               step === "Representative Contact" ? "Our representative will contact you" :
                               "Complete the merchant onboarding process"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="update-notice text-center mb-4">
                    <div className="update-icon mb-3">
                      <i className="fas fa-bell"></i>
                    </div>
                    <p className="update-text">
                      You will receive SMS/Email updates on your application status
                    </p>
                    <div className="update-indicator"></div>
                  </div>

                  <div className="action-buttons">
                    <button className="btn btn-outline-primary btn-lg w-100" onClick={handleBackHome}>
                      <i className="fas fa-home me-2"></i>
                      Back to Home
                    </button>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return <>{currentView === 'success' ? <SuccessPage /> : <TrackingPage />}</>;
};
export default MerchantInquiryStatus;
